import { render, staticRenderFns } from "./changeBudget.vue?vue&type=template&id=5dec8943"
import script from "./changeBudget.vue?vue&type=script&lang=js"
export * from "./changeBudget.vue?vue&type=script&lang=js"
import style0 from "./changeBudget.vue?vue&type=style&index=0&id=5dec8943&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports